<template>
    <b-overlay :show="show" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
        <b-card title="">
            <!-- <b-card-text>Privilege.</b-card-text> -->
            <b-row>
                <div class="d-flex justify-content-between flex-wrap">
                <!-- Parent -->
                <b-col cols="12">
                    <b-form-group label="Parent" label-for="v-parent">
                        <validation-provider #default="{ errors }" name="Parent" rules="required">
                            <v-select disabled id="v-parent" v-model="form.select_1" placeholder="Chose Parent"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="ParentOptions"
                                :reduce="ParentOptions => ParentOptions.value" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <!-- Level -->
                <b-col cols="12">
                    <b-form-group label="Level" label-for="v-level">
                        <validation-provider #default="{ errors }" name="Level" rules="required">
                            <b-form-input disabled id="v-level" :state="errors.length > 0 ? false : null"
                                v-model="form.text_2" placeholder="Level" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </div>
            <div class="d-flex justify-content-between flex-wrap">
                <!-- Code -->
                <b-col cols="12">
                    <b-form-group label="Code" label-for="v-product-code">
                        <validation-provider #default="{ errors }" name="Code" rules="required">
                            <b-form-input disabled id="v-product-code" :state="errors.length > 0 ? false : null"
                                v-model="form.text_3" placeholder="Code" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                <!-- Name -->
                <b-col cols="12">
                    <b-form-group label="Name" label-for="v-product-name">
                        <validation-provider #default="{ errors }" name="Name" rules="required">
                            <b-form-input disabled id="v-product-name" :state="errors.length > 0 ? false : null"
                                v-model="form.text_4" placeholder="Name" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </div>
            <div class="d-flex justify-content-between flex-wrap">
                <!-- Order -->
                <b-col cols="12">
                    <b-form-group label="Order" label-for="v-product-order">
                        <validation-provider #default="{ errors }" name="Order" rules="required">
                            <b-form-input disabled id="v-product-order" type="number"
                                :state="errors.length > 0 ? false : null" v-model="form.text_8" placeholder="Order" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <!-- Icon -->
                <b-col cols="12">
                    <b-form-group label="Icon" label-for="v-product-icon">
                        <validation-provider #default="{ errors }" name="Icon">
                            <b-form-input disabled id="v-product-icon" :state="errors.length > 0 ? false : null"
                                v-model="form.text_5" placeholder="Icon" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </div>
            <div class="d-flex justify-content-between">
                <!-- Slug -->
                <b-col cols="11">
                    <b-form-group label="Slug" label-for="v-product-slug">
                        <validation-provider #default="{ errors }" name="Slug">
                            <b-form-input disabled id="v-product-icon" :state="errors.length > 0 ? false : null"
                                v-model="form.text_6" placeholder="Slug" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <!-- Category -->
                <b-col cols="11">
                    <b-form-group label="Url" label-for="v-product-url">
                        <validation-provider #default="{ errors }" name="Url">
                            <b-form-input disabled id="v-product-url" :state="errors.length > 0 ? false : null"
                                v-model="form.text_7" placeholder="Url" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </div>
            </b-row>
        </b-card>
        <!--Privillage-->
        <b-card-code title="" no-body>
    <div><div class="h-50 d-inline-block"></div></div>
    <div class="d-flex justify-content-between flex-wrap">
      <!-- sorting  -->
      <b-form-group label="Sort" label-size="sm" label-align-sm="left" label-cols-sm="3" label-for="sortBySelect" class="ml-1">
        <b-input-group size="sm">
          <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" >
            <template #first>
              <option value="">
                none
              </option>
            </template>
          </b-form-select>
          <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <!-- filter -->
      <b-form-group label="Filter" label-cols-sm="2" label-align-sm="left" label-size="sm" label-for="filterInput" class="mr-1" >
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search"/>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table striped hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
      <template #cell(avatar)="data">
        <b-avatar :src="data.value" />
      </template>
      <template #cell(created_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(action)="row">
        <span>
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item>
              <b-link :to="{ path: '/privilege/category/detail/edit/'+ row.item.id}">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link v-b-modal.modal-center
              @click="rowOnDelete(row.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
              </b-link>
            </b-dropdown-item>
          </b-dropdown>
        </span>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
      </b-form-group>
      <!-- pagination -->
      <div>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
</b-card-code>
    </b-overlay>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BCardText, BModal, VBModal, BDropdownItem, BDropdown, BLink, BCardBody, BInputGroupAppend, BInputGroup, BPagination, BFormSelect, BBadge, BAvatar, BTable, BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapState } from 'vuex'
export default {
    components: { vSelect, BCardText, BModal, ToastificationContent, BDropdownItem, BDropdown, BLink, BCardBody, BInputGroupAppend, BInputGroup, BPagination, BFormSelect, BBadge, BCardCode, BTable, BAvatar, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
    directives: { Ripple, 'b-modal' : VBModal },
    data() {
        return {
            form: { id: null, select_1: '', text_2: '', text_3: '', text_4: '', text_5: '', text_6: '', text_7: '', text_8: '' },
            show: false,
            required,
            dir: false,
            currentPage: 1,
            sortBy: '',
            perPage: 5,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            status: [{
                AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
            },
            {
                AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
            }],
            modalShow: false,
            tempData: {
               id:null,
               select_1:'',
               text_2 :'',
               text_3 :'',
               text_4 :'',
               text_5 :'',
               text_6 :'',
               text_7 :'',
               text_8 :'',
              },
            tempTable: []
        }
    },
    computed: {
        ...mapState({
            ParentOptions: state => state.privilegeCategory.options,
            totalRows: state => state.privilegeCategory.totalRows,
            fields: state => state.privilegeCategory.fields,
            items: state => state.privilegeCategory.items,
            pageOptions: state => state.privilegeCategory.pageOptions,
        }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
    },
    created() {
        this.$store.dispatch('privilegeCategory/getAll')
    },
    methods: {
        validationForm() {
            this.show = true
            this.$refs.simpleRules.validate()
                .then(success => {
                    if (success) {
                        const formData = this.form
                        this.$store.dispatch('privilegeCategory/formPostPut', formData)
                            .then(res => {
                                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                            },
                                err => {
                                    this.show = false
                                    this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                                })
                    } else {
                        this.show = false
                        this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                    }
                })
        },
        notification(a, b, c, d) {
            this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: { title: a, icon: b, variant: c, text: d }
            })
        },
        getData(id) {
            this.$store.dispatch('privilegeCategory/getById', id).then(data => {
                this.form.id = data.id
                this.form.select_1 = data.parent_id
                this.form.text_2 = data.level
                this.form.text_3 = data.code
                this.form.text_4 = data.name
                this.form.text_5 = data.icon
                this.form.text_6 = data.slug
                this.form.text_7 = data.url
                this.form.text_8 = data.order
                this.show = false
            })
        },
        info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch (val) {
      this.searchTerm = val
    },
    rowOnDelete (id) {
      this.$bvModal
      .msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
      })
      .then(value => {
        if (value === true){
          this.$store.dispatch('privilegeCategory/remove', id)
          .then(response => {
            if (response.status === 200) {
              this.$store.dispatch('privilegeCategory/getAll')
              this.notification('Success','CheckIcon','success','You have successfully')
            } else {
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          },
          error => {
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          }) 
        }
      })
    },
    showModal() {
      this.modalShow = true;
    },
    addToTempTable() {
      this.tempTable.push({ ...this.tempData });
      this.tempData.id = null;
      this.tempData.select_1 = '';
      this.tempData.text_2 = '';
      this.tempData.text_3 = '';
      this.tempData.text_4 = '';
      this.tempData.text_5 = '';
      this.tempData.text_6 = '';
      this.tempData.text_7 = '';
      this.tempData.text_8 = '';
    }
    },
    mounted() {
        if (this.$route.params.id) {
            this.show = true
            this.getData(this.$route.params.id)
        }
        this.$store.state.totalRows = this.items.length
    },
    created () {
    this.$store.dispatch('privilegeCategory/getAll')
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>